/* eslint-disable @typescript-eslint/no-var-requires */

export default {
    Logo: require('./logo.png'),
    // login
    icUserDark: require('./ic-user-dark.svg').default,
    icUserLg: require('./ic-user-lg.svg').default,
    icUser: require('./ic-user.svg').default,
    icPassword: require('./ic-eye.svg').default,
    icShowPassword: require('./ic-show-password.svg').default,
    LoginBanner: require('./patient-login-banner.jpg'),

    // signup
    captcha: require('./captcha-code.png'),
    downArrow: require('./ic-down-arrow.svg').default,

    // header
    helpIc: require('./ic-help-circle-outline.svg').default,
    dp: require('./dp.png'),
    logoutIc: require('./ic-logout.svg').default,
    completeGray: require('./complete.svg').default,
    notiDark: require('./ic-notification-dark.svg').default,
    labResultGrayIc: require('./ic-lab-result-gray.svg').default,
    settingDark: require('./ic-setting-dark.svg').default,

    datepicker: require('./ic-datepicker.svg').default,
    timepicker: require('./ic-timepicker.svg').default,
    // initial-plan
    DrGroup: require('./ic-dr-group.svg').default,
    // sidebar
    timeline: require('./ic-timeline.svg').default,
    closeDark: require('./ic-close-dark.svg').default,
    providers: require('./ic-providers.svg').default,
    clinicalSummary: require('./ic-clinical-summary.svg').default,
    appointments: require('./ic-appointments.svg').default,
    messageoutline: require('./ic-message-outline.svg').default,
    docs: require('./ic-docs.svg').default,
    medDocs: require('./ic-med-docs.svg').default,
    refill: require('./ic-refill.svg').default,
    urgentCare: require('./ic-urgent-care.svg').default,
    visitSummary: require('./ic-visit-summary.svg').default,
    questionnaire: require('./ic-questionnaire.svg').default,
    medication: require('./ic-medication.svg').default,
    psLab: require('./ic-ps-lab.svg').default,
    imageIc: require('./ic-image.svg').default,
    allergies: require('./ic-allergies.svg').default,
    problemList: require('./ic-problem-list.svg').default,
    procedures: require('./ic-procedures.svg').default,
    reports: require('./ic-reports.svg').default,
    immunizations: require('./ic-immunizations.svg').default,
    insurance: require('./ic-insurance.svg').default,
    diet: require('./ic-diet.svg').default,
    vitals: require('./ic-vitals.svg').default,
    pharmacy: require('./ic-pharmacy.svg').default,
    billings: require('./ic-billings.svg').default,

    search: require('./ic-search.svg').default,
    download: require('./ic-download.svg').default,
    downloadGray: require('./ic-download-gray.svg').default,
    icUpload: require('./ic-upload.svg').default,
    icVitalGeneral: require('./ic-vital-general.svg').default,
    icVitalTemperature: require('./ic-vital-temperature.svg').default,
    icBloodPressure: require('./ic-blood-pressure.svg').default,
    icVitalPulse: require('./ic-vital-pulse.svg').default,
    send: require('./ic-send.svg').default,
    add: require('./ic-add.svg').default,
    addGray: require('./ic-add-gray.svg').default,
    deleteBlue: require('./ic-delete-blue.svg').default,
    editGray: require('./ic-edit-line-gray.svg').default,
    deleteGray: require('./ic-delete-gray.svg').default,
    leftArrow: require('./ic-left-arrow.svg').default,
    back: require('./ic-back.svg').default,
    lab: require('./lab.svg').default,
    callGray: require('./ic-phone-call.svg').default,
    closedark: require('./ic-closeDark.svg').default,
    notification: require('./ic-notification-blue.svg').default,
    edit: require('./ic-edit.svg').default,
    IcGridColumnPrimary: require('./ic-grid-column-primary.svg').default,
    IcGridColumnWhite: require('./ic-grid-column-white.svg').default,
    IcGridRowPrimary: require('./ic-grid-row-primary.svg').default,
    IcGridRowWhite: require('./ic-grid-row-white.svg').default,
    IcRescheduleAppointment: require('./ic-reschedule-appointment.svg').default,
    IcVideoOffDefault: require('./ic-video-off-default.svg').default,
    IcVideoWhite: require('./ic-video-white.svg').default,
    IcMicWhite: require('./ic-mic-white.svg').default,
    IcMicOffDefault: require('./ic-mic-off-default.svg').default,
    AccessDialogPending: require('./access-dialog-pending.png'),
    AcessDialogRejected: require('./access-dialog-rejected.png'),
    IcSpeaker: require('./ic-speaker.svg').default,
    IcMoreVerticalGrey: require('./ic-more-vertical-grey.svg').default,
    IcEscalationOrange: require('./ic-escalation-orange.svg').default,
    PaymentProcessing: require('./payment-process.svg').default,
    SuccessCheckPrimary: require('./success-check-primary.svg').default,
    IcVisaCard: require('./ic-visa-card.svg').default,
    IcMasterCard: require('./ic-master-card.svg').default,
    IcJcbCard: require('./ic-jcb-card.svg').default,
    IcDiscoverCard: require('./ic-discover-card.svg').default,
    IcDinnersClubCard: require('./ic-dinners-club-card.svg').default,
    IcDefaultCard: require('./ic-default-card.svg').default,
    IcAmexCard: require('./ic-amex-card.svg').default,
    IcFillForm: require('./ic-consent.svg').default,
    IcHistory: require('./ic-history.svg').default,
    IcRenew: require('./ic-renew.svg').default,
    IcCloseGrey: require('./ic-close-grey.svg').default,
    IcMembership: require('./ic-membership.svg').default,
    IcInformationDefault: require('./ic-information-gray.svg').default,
};
